import React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ErrorFallBack from "./components/Error/ErrorFallBack";

import LloydsProject from "./components/Projects/LloydsRevamp";
import BabbelProject from "./components/Projects/BabelRevamp";
import AgileProject from "./components/Projects/AgileRevamp";
import KfcProject from "./components/Projects/KFCRevamp";
import ChapterProject from "./components/Projects/ChapterRevamp";
import JustEatTakeawayProject from "./components/Projects/JustEatTakeawayRevamp";
import IdealProject from "./components/Projects/IdealRevamp";
import CodamDevelopmentProject from "./components/Projects/CodamDevelopmentRevamp";
import CodamMentoringProject from "./components/Projects/CodamMentoringRevamp";
import EmergingIndustriesProject from "./components/Projects/EmergingIndustriesRevamp";
import HanProject from "./components/Projects/HanRevamp";

import App from "./App";

import "./index.css";

const router = createBrowserRouter([
  { path: "/", element: <App />, errorElement: <ErrorFallBack props={{}} /> },
  {
    path: "/project/agile",
    element: <AgileProject />,
    errorElement: <ErrorFallBack props={{}} />,
  },
  {
    path: "/project/emerging-industries",
    element: <EmergingIndustriesProject />,
    errorElement: <ErrorFallBack props={{}} />,
  },
  {
    path: "/project/codam-mentoring",
    element: <CodamMentoringProject />,
    errorElement: <ErrorFallBack props={{}} />,
  },
  {
    path: "/project/han",
    element: <HanProject />,
    errorElement: <ErrorFallBack props={{}} />,
  },
  {
    path: "/project/ideal",
    element: <IdealProject />,
    errorElement: <ErrorFallBack props={{}} />,
  },
  {
    path: "/project/thuisbezorgd",
    element: <JustEatTakeawayProject />,
    errorElement: <ErrorFallBack props={{}} />,
  },
  {
    path: "/project/codam-professional-development",
    element: <CodamDevelopmentProject />,
    errorElement: <ErrorFallBack props={{}} />,
  },
  {
    path: "/project/chapter-works",
    element: <ChapterProject />,
    errorElement: <ErrorFallBack props={{}} />,
  },
  {
    path: "/project/kfc",
    element: <KfcProject />,
    errorElement: <ErrorFallBack props={{}} />,
  },
  {
    path: "/project/babbel",
    element: <BabbelProject />,
    errorElement: <ErrorFallBack props={{}} />,
  },
  {
    path: "/project/lloyds",
    element: <LloydsProject />,
    errorElement: <ErrorFallBack props={{}} />,
  },
]);

const container = document.getElementById("root");
createRoot(container!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
